import type { Feature } from "./registry";
import { audio } from "../audio/audio";
import { motionOk } from "../ui/kit";
import { RewardFly } from "../ui/rewardFly/rewardFly";
import { readHoldings } from "../ui/rewardFly/holdings";
import { setRewardFly } from "../ui/rewardFly/link";

/**
 * Reward fly-to-home (owner 2026-10-24, ui/rewardFly/rewardFly.ts): every save is checked for gains, the hub's coming
 * back flies what was won away from it, and a tap anywhere names the default origin. Nothing in the save.
 */

/** Each landing clinks a little higher (docs/AUDIO.md: `chestCollect` is "a coin into the wallet"). */
const CLINK_PITCH_STEP = 0.03;

export const rewardFlyFeature: Feature = {
  id: "rewardFly",
  register(ctx, registry) {
    const fly = new RewardFly({
      read: () => readHoldings(ctx.catalog),
      motionOk,
      landSound: (n) => { try { audio.play("chestCollect", 0, 1 + CLINK_PITCH_STEP * n); } catch { /* no audio yet */ } },
      hubUp: () => typeof document !== "undefined" && document.querySelector(".hub") !== null,
      // a chest opened over the screen (achievements, orders, crates, the battle's): its COLLECT sends the loot home
      held: () => typeof document !== "undefined" && document.querySelector(".chesthost") !== null,
      now: () => performance.now(),
    });
    setRewardFly(fly);
    registry.afterPersist(() => fly.check());
    // the button a reward was claimed with: a click on its way down (read only, never stopped)
    if (typeof document !== "undefined") document.addEventListener("click", (e) => fly.noteTap(e.target instanceof Element ? e.target : null, e.clientX, e.clientY), { capture: true, passive: true });
    let lastHub: Element | null = null;
    registry.hubWidget({
      id: "rewardFly",
      mount: (_hub, layer) => {
        // mounted on every hub render: only a new hub (back from a battle, the title) flies what waited for it
        const root = layer.closest(".hub");
        if (root !== lastHub) { lastHub = root; fly.hubShown(); }
        return { dispose: () => undefined };
      },
    });
  },
};
